import { apiRequest } from '@/shared/services/apiClient.js';

export const notificationService = {
  async getNotifications() {
    return apiRequest('/auth/messages', { method: 'GET' });
  },

  async markAsRead(messageId) {
    if (!messageId) {throw new Error('Notification id is required');}
    return apiRequest(`/auth/messages/read/${messageId}`, {
      method: 'PUT',
    });
  },

  async deleteNotification(messageId) {
    if (!messageId) {throw new Error('Notification id is required');}
    return apiRequest(`/auth/messages/delete/${messageId}`, {
      method: 'DELETE',
    });
  },

  async deleteAllNotifications() {
    return apiRequest('/auth/messages/delete-all', {
      method: 'DELETE',
    });
  },
};

export default notificationService;

